<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<ul class="nav top-navbar bg-white border-bottom justify-content-center pt-4 rounded-top text-lg text-dark text-bold">
  <li [class.active]="activeTab === 'ios'">
    <a (click)="activeTab = 'ios'"> <ng-container i18n>iOS</ng-container> </a>
  </li>
  <li [class.active]="activeTab === 'android'">
    <a (click)="activeTab = 'android'"> <ng-container i18n>Android</ng-container> </a>
  </li>
</ul>
<div class="modal-body bg-none d-flex flex-column align-items-center m-0 px-5 py-4">
  <div class="mt-3" i18n>Scan this QR code to open AdvanceCM in the Apple Store.</div>
  <qrcode
    [qrdata]="activeTab === 'ios' ? iosUrl : androidUrl"
    [width]="256"
    [errorCorrectionLevel]="'M'"
    class="d-flex justify-content-center"
  ></qrcode>
  <p class="">
    <ng-container i18n>QR code not working? Try using this</ng-container>&nbsp;<a
      [href]="activeTab === 'ios' ? iosUrl : androidUrl"
      target="_blank"
      i18n
      >link</a
    >
  </p>
</div>
